import { createElement } from 'react';
import { Address } from './Summary.components.styles';
import { SUMMARY_COMPONENTS_CONST } from './Summary.components.d';
import { addressMapper } from './address-mapper';
import type { AddressProps } from './Summary.components.d';

const AddressBase = ({
  businessModelCode = 1,
  distributionCenterAddress,
  fullAddress,
  isWithdrawal,
}: AddressProps) => {
  const elementAddress = addressMapper[businessModelCode];

  if (!elementAddress) {
    return null;
  }

  return (
    <Address.Component data-testid={SUMMARY_COMPONENTS_CONST.ADDRESS_TEST_ID}>
      {createElement(elementAddress, { distributionCenterAddress, fullAddress, isWithdrawal })}
    </Address.Component>
  );
};

export default AddressBase;
